import { createTypedHooks } from "easy-peasy";
import { StoreModel } from "../store/models";

const typedHooks = createTypedHooks<StoreModel>();

export const { useStoreState } = typedHooks;
export const { useStoreActions } = typedHooks;
export const { useStoreDispatch } = typedHooks;
